import React, { useState, useEffect, useRef, useCallback } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import { useSocketContext } from '../../../../_providers/Socket'
import { useAuthDataContext } from '../../../../_providers/Auth'

import loader from '../../../../assets/img/loader.svg'
import visitpriceHeadImage from '@/assets/img/reservations/icons/visitprice-head.svg'

import Question from '../../../modals/messages/Question'
import AddEditTodo from './modals/AddEditTodo'
import TodoModal from '../../todo/partials/modals/View'
import TodoMenu from './TodoMenu'

function TaskInfoTodos({ reservationId, data }) {
    const [todos, setTodos] = useState({
        loading: true,
        data: [],
    })

    const addEditRef = useRef(null)
    const viewRef = useRef(null)
    const questionRef = useRef(null)

    const listener = useSocketContext()
    const auth = useAuthDataContext()
    const partnerId = auth.partnerId()

    const loadTodos = useCallback(() => {
        if (!reservationId) return

        Api.get('reservations/todos?id=' + reservationId)
            .then(res => setTodos({ loading: false, data: res.data }))
    }, [reservationId])

    useEffect(() => {
        loadTodos()
    }, [loadTodos])

    // Refresh the todos list whenever the backend broadcasts a change
    useEffect(() => {
        if (!listener || !partnerId || !reservationId) return

        const channel = listener.private(`partners.${partnerId}.reservation.${reservationId}`)

        const handleTodoChanged = () => {
            loadTodos()
        }

        channel.listen('ReservationTodoChanged', handleTodoChanged)

        return () => {
            channel.stopListening('ReservationTodoChanged', handleTodoChanged)
        }
    }, [listener, partnerId, reservationId, loadTodos])

    const handleView = todo => viewRef.current.open(todo)

    const handleEdit = id => addEditRef.current.open(id)

    const handleDelete = id => questionRef.current.open(id)

    const handleConfirmDelete = id => {
        Api.post('reservations/todos/delete', { id: reservationId, todo_id: id }).then(() => {
            setTodos(prev => ({ ...prev, data: prev.data.filter(t => t.id !== id) }))
        })
    }

    const handleComplete = id => {
        Api.post('todos/mark-as-completed', { id }).then(res => {
            setTodos(prev => ({
                ...prev,
                data: prev.data.map(t => t.id === id ? res.data : t),
            }))
        })
    }

    const handleAdded = () => {
        loadTodos()
    }

    return (
        <div className="pannel">
            <AddEditTodo
                ref={addEditRef}
                callback={handleAdded}
                reservationData={data}
                noRedirect
            />
            <TodoModal ref={viewRef} handleRead={() => { }} />
            <Question
                mainMessage={trans('headings.question6')}
                secondaryMessage={trans('subheadings.confirmDelete')}
                ref={questionRef}
                callback={handleConfirmDelete}
            />
            <div className="head">
                <img src={visitpriceHeadImage} alt="visitation" />
                {trans('tabs.todo')}

            </div>
            {todos.loading
                ? <img src={loader} alt="loading" />
                :
                <>
                    {todos.data.length === 0
                        ? <div className="alert warning" style={{ marginBottom: 0 }}>{trans('messages.noResultsFound')}</div>
                        : <ul className="notes-list">
                            {todos.data.map(todo =>
                                <li key={'td-' + todo.id}>
                                    <div className={`task-priority ${todo.priority.name === 'low' ? 'low' : todo.priority.name === 'normal' ? 'medium' : 'high'}`} />
                                    <div className="title">
                                        <b>{todo.title}</b>
                                        <p>
                                            {todo.tags && todo.tags.length > 0
                                                ? todo.tags.map(t => t.employee ? `${t.employee.name} ${t.employee.lastname ?? ''}` : '').filter(Boolean).join(', ')
                                                : todo.author ? `${todo.author.name} ${todo.author.lastname}` : ''
                                            }
                                        </p>
                                    </div>
                                    <div className="time">
                                        {todo.date_dmy}
                                    </div>
                                    {data.can_modify &&
                                        <div className="options">
                                            <TodoMenu
                                                wrapper="div"
                                                each={todo}
                                                isCompleted={todo.completed_at}
                                                canMarkAsCompleted={todo.can_mark_as_completed}
                                                handleView={handleView}
                                                handleEdit={handleEdit}
                                                handleDelete={handleDelete}
                                                handleComplete={handleComplete}
                                            />
                                        </div>
                                    }
                                </li>
                            )}
                        </ul>
                    }
                    {data.can_modify &&
                        <button
                            type="button"
                            className="button button-add button-small"
                            style={{ marginTop: 15 }}
                            onClick={() => addEditRef.current.open()}
                        >
                            {trans('buttons.newTodo')}
                        </button>
                    }
                </>

            }
        </div>
    )
}

export default TaskInfoTodos
